export function GetAppCRA(url, needle) {
    return GetAdjustedUrl(url, needle, 'cra', 'magstimcra');
}

export function GetAppPDM(url, needle) {
    return GetAdjustedUrl(url, needle, 'pdm', 'magstimpdm');
}

export function GetApiReporting(url, needle) {
    return GetAdjustedUrl(url, needle, 'api-reporting', 'magstimreportingwebapi', '/api');
}

export function GetApiPdm(url, needle) {
    return GetAdjustedUrl(url, needle, 'api-pdm', 'magstimpdmwebapi', '/api');
}

export function GetApiAnalytics(url, needle) {
    return GetAdjustedUrl(url, needle, 'api-analytics', 'magstimanalyticswebapi', '/api');
}

export function GetAppAnalytics(url, needle) {
    return GetAdjustedUrl(url, needle, 'analytics', 'magstimanalytics');
}


export function GetBuildConfigType(appName, hostname, defaultValue) {
    var retVal = 'live';
    if (hostname.includes('localhost')) {
        retVal = defaultValue;
    }
    else if (hostname.includes(`${appName}-qa`)) {
      retVal = 'qa';
    }
    else if (hostname.includes(`${appName}-devci`)) {
      retVal = 'devci';
    }
  
    console.log(`appName=${appName} hostname=${hostname} defaultValue=${defaultValue} retVal=${retVal} `);

    return retVal;
  }

function GetAdjustedUrl(url, needle, replacement, replacementAzure, postfix) {
    url = url.toLowerCase();

    const schemes = [ 'https', 'http'];
    var scheme = '';
    for (var x = 0; x < schemes.length; x++) {
        if (url.startsWith(`${schemes[x]}://`)) {
            scheme = `${schemes[x]}://`;
            url = url.substring(`${schemes[x]}://`.length);
            break;
        }
    }

    // console.log(`url=${url} needle=${needle} replacement=${replacement} replacementAzure=${replacementAzure} scheme=${scheme}`);

    const needleAzure = `magstim${needle}`;
    if (url.startsWith(needleAzure)) {
        needle = needleAzure;
        replacement = replacementAzure;
    }
    else if (url.startsWith(needle)) {
        // all good
    }
    else {
        needle = null;
    }

    // console.log(`url=${url} needle=${needle} replacement=${replacement} replacementAzure=${replacementAzure} scheme=${scheme}`);

    var retVal;

    if (null !== needle) {

        url = url.substring(needle.length);

        const index = url.indexOf('/');

        if (index >= 0) {
            url = url.substring(0, index);
        }

        retVal = `${scheme}${replacement}${url}`;

        if (undefined !== postfix) {
            retVal = `${retVal}${postfix}`;
        }
    }
    
    // console.log(`url=${url} needle=${needle} replacement=${replacement} replacementAzure=${replacementAzure} scheme=${scheme} retVal=${retVal}`);
    
    return retVal;
}
